import { Outlet } from 'react-router';

import { useStorefrontFeatures, type FeatureKey } from '@/features/storefront/features';
import { StorefrontNotFoundPage } from '@/features/storefront/pages/StorefrontNotFoundPage';

/**
 * Gate for a page the merchant has turned off.
 *
 * Renders the shop's own 404 rather than redirecting anywhere. A redirect
 * loses the address the shopper typed, can loop if the place it lands is also
 * switched off, and answers a question nobody asked - whereas this page is
 * already the shop's way of saying "there is nothing at this address": it
 * wears the merchant's theme, sits inside their chrome and carries their way
 * back into the catalog. It is also exactly what the API says about the same
 * resource, so the two halves of the answer agree.
 *
 * The features context defaults to all-on, so a shop rendered without a
 * provider - a theme's sample shop, a component test - passes straight
 * through here, which is what let this gate be added without touching either.
 */
export function RequireFeature({ feature }: { feature: FeatureKey }) {
  const features = useStorefrontFeatures();

  if (!features[feature]) return <StorefrontNotFoundPage />;
  return <Outlet />;
}
